import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks';
import { FaxManagement } from 'pages/faxes';

export const FaxManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('faxes');

  return isExpired ? (
    <TokenExpired />
  ) : canAccess || isAdmin ? (
    <FaxManagement />
  ) : (
    <Unauthorized />
  );
};
